function searchParamsFrom(search = "") {
  if (search instanceof URLSearchParams) return search;
  const value = String(search || "");
  return new URLSearchParams(value.startsWith("?") ? value.slice(1) : value);
}

export function hasAttendanceOperationalContext(search = "") {
  const params = searchParamsFrom(search);
  return (
    params.has("service") ||
    params.has("serviceId") ||
    params.has("occurrence") ||
    params.has("session") ||
    params.has("token") ||
    params.get("mode") === "kiosk"
  );
}

export function getAttendanceRouteMode(search = "") {
  const params = searchParamsFrom(search);
  if (hasAttendanceOperationalContext(params)) return "operational";
  if (params.get("view") === "my-attendance") return "member";
  return "admin";
}

export function getChildrenCheckInRouteMode(search = "") {
  return hasAttendanceOperationalContext(search) ? "operational" : "entry";
}
